<template>
    <div class="accordion" id="accordionCondicion">
        <div class="accordion-item opcionDetalle">
            <h2 class="accordion-header" id="headingCondicion">
                <button
                    class="
                        accordion-button
                        collapsed
                        btn btn-primary
                        rounded-pill
                    "
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseCondicion"
                    aria-expanded="false"
                    aria-controls="collapseCondicion"
                >
                    Condiciones
                </button>
            </h2>
            <div
                id="collapseCondicion"
                class="accordion-collapse collapse"
                aria-labelledby="headingCondicion"
                data-bs-parent="#accordionCondicion"
            >
                <div class="accordion-body">
                    <div class="card card-body mb-3 cabeceraDetalle">
                        <ul class="text-start">
                            <li class="me-4 mb-3" v-for="condicion in condiciones" :key="condicion" v-show="condicion !== ''">
                                {{ condicion }}
                            </li>
                        </ul> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'DetalleCondicionesOperacion',

    props: {
        operacion: {},
    },

    data() {
        return {
            condiciones: ''
        }
    },

    mounted() {
        this.condiciones = (this.operacion.condicionantes != null && this.operacion.condicionantes != undefined) ? this.operacion.condicionantes.split(',').filter(c => c !== '') : ""
    }
})
</script>

<style scoped>
    h5 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 22px;
        color: #4d4f5c;
    }

    li,
    p,
    span {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 21px;
        color: #302d74;
        text-align: justify;
    }

    .opcionDetalle {
    border: none;
    }

    .cabeceraDetalle {
    margin-top: -45px;
    margin-left: -20px;
    margin-right: -20px;
    padding-top: 45px;
    }

    .cuerpoDetalle {
    margin-left: -20px;
    margin-right: -20px;
    }

    .btn {
    z-index: 10;
    font-weight: 600;
    font-size: 18px;
    }

    .card-body {
    border: none;
    filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.239));
    }

    @media (min-width: 992px) {
        .cabeceraDetalleI {
            margin-top: -45px;
            margin-left: -20px;
            padding-top: 45px;
        }

        .cabeceraDetalleD {
            margin-top: -45px;
            margin-right: -20px;
            padding-top: 45px;
        }

        .cuerpoDetalleI {
            margin-left: -20px;
        }

        .cuerpoDetalleD {
            margin-right: -20px;
        }
    }

    @media (max-width: 992px) {
        .cabeceraDetalleI {
            margin-top: -45px;
            margin-left: -20px;
            margin-right: -20px;
            padding-top: 45px;
        }

        .cabeceraDetalleD {
            margin-top: 0px;
            margin-left: -20px;
            margin-right: -20px;
        }

        .cuerpoDetalleI {
            margin-left: 0px;
            margin-left: -20px;
            margin-right: -20px;
        }

        .cuerpoDetalleD {
            margin-right: 0px;
            margin-left: -20px;
            margin-right: -20px;
        }

        #iconoE {
            font-size: 35px;
        }
    }
</style>